import React, { ReactElement } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import './dropdownListButtons.scss';
import send from '../icons/send.svg';
import UserRole from '../../../model/currentuser/UserRole';
import Secured from '../../Secured';
import { useUserContext } from '../../../context/UserContext';
import { canSendOrAdd } from '../../../function/permissions';
import routes from '../../../routing/routes';

interface Props {
  setOpenDropdown: (open: boolean) => void;
}

const SendPripomienkyButton = ({ setOpenDropdown }: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { pouzivatel, legislationProcess } = useUserContext();

  const navigateToSendPripomienkyPage = (): void => {
    if (!location.pathname.startsWith(routes.sendPripomienky.withParams(type, year, index))
        && !location.pathname.endsWith(routes.sendPripomienky.withParams(type, year, index))) {
      navigate(routes.sendPripomienky.withParams(type, year, index));
    } else {
      setOpenDropdown(false);
    }
  };

  return (
    <Secured
      allowForRoles={[UserRole.NELEGISLATIVNA_ORGANIZACIA, UserRole.ODOSIELATEL]}
      additionalCheck={canSendOrAdd(pouzivatel, legislationProcess)}
    >
      <li key="Odoslať pripomienky" className="action-item">
        <div className="icon-wrapper">
          <img src={send} className="icon" alt="Odoslať pripomienky" />
        </div>
        <button
          onClick={navigateToSendPripomienkyPage}
          className="button-inline-text send-comments-button idsk-link"
          type="button"
        >Odoslať pripomienky
        </button>
      </li>
    </Secured>
  );
};
export default SendPripomienkyButton;
